exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recorder {\n  max-width: 280px; }\n  .recorder div.filename {\n    margin-bottom: 7px;\n    font-size: 10px;\n    text-align: center; }\n  .recorder div.action {\n    float: left;\n    width: 40px;\n    position: relative;\n    text-align: center;\n    font-size: 23px;\n    cursor: pointer; }\n    .recorder div.action p {\n      margin: 0; }\n  .recorder .active-icon {\n    font-size: 33px !important;\n    padding: 0 !important; }\n  .recorder .recording {\n    color: red;\n    animation: flash linear 1s infinite; }\n  .recorder .playing {\n    color: #07c;\n    animation: flash linear 1s infinite; }\n\n@keyframes flash {\n  0% {\n    opacity: 1; }\n  50% {\n    opacity: 0.1; }\n  100% {\n    opacity: 1; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/components/voice-recorder/voice-recorder.component.scss
// module id = ../../../../../src/app/shared/components/voice-recorder/voice-recorder.component.scss
// module chunks = main